var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#669df6;}.cls-2{fill:#4285f4;}.cls-3{fill:none;}.cls-4{fill:#aecbfa;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_Scheduler_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,21a1,1,0,0,1-.7-.29l-2-2a1,1,0,0,1,1.41-1.41l2,2a1,1,0,0,1,0,1.41A1,1,0,0,1,20,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,21a1,1,0,0,1-.7-1.71l2-2a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-2,2A1,1,0,0,1,4,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.47,17.13,4.25,18.35a11.13,11.13,0,0,0,1.42,1.41l1.22-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.73,18.31l-1-1a1.19,1.19,0,0,0-.23-.16l-1.34,1.34a1.19,1.19,0,0,0,.16.23l1,1A11.13,11.13,0,0,0,19.73,18.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "colored-32/scheduler"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,21a9,9,0,1,1,9-9A9,9,0,0,1,12,21Zm0-2a7,7,0,1,0-7-7A7,7,0,0,0,12,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "cls-2",
    d: "M12,17a5,5,0,0,0,5-5,5,5,0,0,0-5-5v5L7.92,14.91A5,5,0,0,0,12,17Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4,6.07a1,1,0,0,1-.71-1.71l2-2a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-2,2A1,1,0,0,1,4,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20,6.07a1,1,0,0,1-.71-.3l-2-2a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l2,2A1,1,0,0,1,20,6.07Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCron);
export default __webpack_public_path__ + "static/media/cron.47fd77ae30c6c8aa9f965432f1866618.svg";
export { ForwardRef as ReactComponent };